(function () {
  var reducedMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
  var animationContext = null;
  var headerTrigger = null;

  function ready(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback, { once: true });
      return;
    }

    callback();
  }

  function setupHeaderState() {
    var header = document.querySelector(".site-header");

    if (!header || !window.ScrollTrigger) {
      return;
    }

    if (headerTrigger) {
      headerTrigger.kill();
      headerTrigger = null;
    }

    headerTrigger = window.ScrollTrigger.create({
      trigger: document.body,
      start: "top -20",
      end: 99999,
      toggleClass: {
        targets: header,
        className: "site-header--scrolled",
      },
    });
  }

  function setupHero(gsap) {
    var hero = document.querySelector(".hero");

    if (!hero) {
      return;
    }

    var heroItems = hero.querySelectorAll(
      ".hero__text .eyebrow, .hero__heading, .hero__copy, .hero__actions"
    );
    var heroImage = hero.querySelector(".hero__media img");

    if (heroItems.length) {
      gsap.from(heroItems, {
        autoAlpha: 0,
        y: 22,
        duration: 0.75,
        stagger: 0.08,
        ease: "power3.out",
        clearProps: "opacity,visibility,transform",
      });
    }

    if (heroImage) {
      gsap.fromTo(
        heroImage,
        { scale: 1.035 },
        {
          scale: 1,
          duration: 1.4,
          ease: "power2.out",
          clearProps: "transform",
        }
      );
    }
  }

  function revealGroup(gsap, selector, options) {
    var groups = document.querySelectorAll(selector);

    groups.forEach(function (group) {
      var items = group.matches(".section-header, .testimonials__header")
        ? [group]
        : Array.prototype.slice.call(group.children);

      if (!items.length) {
        return;
      }

      gsap.from(items, {
        autoAlpha: 0,
        y: options && options.y ? options.y : 24,
        duration: options && options.duration ? options.duration : 0.65,
        stagger: options && options.stagger ? options.stagger : 0.08,
        ease: "power3.out",
        clearProps: "opacity,visibility,transform",
        scrollTrigger: {
          trigger: group,
          start: "top 82%",
          once: true,
        },
      });
    });
  }

  function setupSectionReveals(gsap) {
    revealGroup(gsap, "[data-animate-group]", { y: 22, duration: 0.65, stagger: 0.07 });
    revealGroup(gsap, ".section-header", { y: 20, duration: 0.6 });
    revealGroup(gsap, ".offer-grid", { y: 26, duration: 0.65, stagger: 0.07 });
    revealGroup(gsap, ".editorial__content", { y: 22, duration: 0.65 });
    revealGroup(gsap, ".testimonials__header", { y: 20, duration: 0.6 });
    revealGroup(gsap, ".testimonials__grid", { y: 24, duration: 0.65, stagger: 0.08 });
    revealGroup(gsap, ".visit-section__content", { y: 22, duration: 0.65 });
  }

  function setupMediaMotion(gsap) {
    var mediaBlocks = document.querySelectorAll(".editorial__media, .visit-section__media");

    mediaBlocks.forEach(function (media) {
      gsap.from(media, {
        autoAlpha: 0,
        y: 34,
        duration: 0.85,
        ease: "power3.out",
        clearProps: "opacity,visibility,transform",
        scrollTrigger: {
          trigger: media,
          start: "top 78%",
          once: true,
        },
      });
    });

    document.querySelectorAll(".editorial__image img, .visit-section__frame img").forEach(function (image) {
      gsap.fromTo(
        image,
        { yPercent: -4, scale: 1.04 },
        {
          yPercent: 4,
          scale: 1.04,
          ease: "none",
          scrollTrigger: {
            trigger: image.parentElement,
            start: "top bottom",
            end: "bottom top",
            scrub: 0.6,
          },
        }
      );
    });

    var quote = document.querySelector(".editorial__quote");

    if (quote) {
      gsap.from(quote, {
        autoAlpha: 0,
        x: 22,
        y: 18,
        duration: 0.7,
        ease: "power3.out",
        clearProps: "opacity,visibility,transform",
        scrollTrigger: {
          trigger: quote,
          start: "top 84%",
          once: true,
        },
      });
    }

  }

  function initAnimations() {
    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;

    if (!gsap || !ScrollTrigger) {
      setupHeaderState();
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    if (animationContext) {
      animationContext.revert();
      animationContext = null;
    }

    setupHeaderState();

    if (reducedMotionQuery.matches) {
      ScrollTrigger.refresh();
      return;
    }

    animationContext = gsap.context(function () {
      setupHero(gsap);
      setupSectionReveals(gsap);
      setupMediaMotion(gsap);
    }, document.documentElement);

    ScrollTrigger.refresh();
  }

  ready(initAnimations);

  window.addEventListener("load", function () {
    if (window.ScrollTrigger) {
      window.ScrollTrigger.refresh();
    }
  });

  document.addEventListener("shopify:section:load", initAnimations);
  document.addEventListener("shopify:section:reorder", initAnimations);

  if (reducedMotionQuery.addEventListener) {
    reducedMotionQuery.addEventListener("change", initAnimations);
  } else if (reducedMotionQuery.addListener) {
    reducedMotionQuery.addListener(initAnimations);
  }
})();
